const Vue = require('vue')
import apihelper from './apihelper'

export default {
    getappdata(p) {
        return apihelper.get("/App/GetAppData", p);
    }
}